exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!react-select/dist/react-select.css"), "");

// module
exports.push([module.id, "/* Override Bootstrap buttons */\n\n.Select-control {\n  border-radius: 0 !important;\n  padding: 5px;\n}\n\n.Select-multi-value-wrapper {\n  width: 100%;\n}\n\n.Select-menu-outer {\n  border-radius: 0 !important;\n}\n\n.Select--multi .Select-value {\n  display: inline-flex;\n  padding: 2px;\n  background-color: #FFDFCA;\n  color: #212040;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  border: none;\n  border-radius: 0;\n}\n\n.Select--multi .Select-value .Select-value-icon {\n  order: 2;\n  background-color: #ffc299;\n  padding-left: 4px;\n  padding-right: 4px;\n  border-right: none;\n  border-radius: 50%;\n}\n\n.Select--multi .Select-value .Select-value-icon:hover {\n  background-color: #ffb380;\n  color: inherit;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/react-select.scss
// module id = 599
// module chunks = 0